module.exports = __webpack_public_path__ + "static/img/Bachelor_010517.4baae23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010517.jpg
// module id = 175
// module chunks = 0